import React from "react";
import { cn } from "../../../utils/cn";

const PresetButton = ({
  name,
  description,
  active,
  onClick,
  disabled = false,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "flex flex-col text-left p-3 border rounded-lg font-fira transition-all duration-200",
        active
          ? "bg-primary/10 border-primary text-foreground terminal-glow-strong scale-[0.98]"
          : "bg-card border-border hover:border-primary/40 hover:bg-muted/10 text-muted-foreground hover:text-foreground",
        disabled && "opacity-40 cursor-not-allowed"
      )}
    >
      <div className="flex items-center justify-between w-full mb-1">
        <span className={cn(
          "text-xs font-bold uppercase tracking-wider",
          active ? "text-primary" : "text-foreground"
        )}>
          {name}
        </span>
        {/* Active Pad Indicator */}
        <div
          className={cn(
            "w-2 h-2 rounded-full transition-all duration-300",
            active
              ? "bg-primary shadow-[0_0_6px_var(--color-primary)]"
              : "bg-muted"
          )}
        />
      </div>
      <p className="text-[9px] font-source leading-snug line-clamp-2 opacity-80">
        {description}
      </p>
    </button>
  );
};

export default PresetButton;
